import React from 'react';
import { UpsellPanelSteps } from '../../../../../constants/upsellPanelEnumsAndConstants';
import { useUpsellWidgetModel } from '../../../hooks/useUpsellWidgetModelContext';
import { useUpsellWidgetContainer } from '../../../hooks/useUpsellWidgetContainerContext';
import Helpers from '../../../../../constants/helpers';

export const Step2SMSTokenHeaderContent = () => {
    const { currentStep, baseProps, headerFontClass, goToStep } = useUpsellWidgetContainer();
    if (currentStep !== UpsellPanelSteps.Step2SMSToken) {
        return null;
    }

    return (
        <div className="t-c">
            <h2 className={`mb-2 font-circular-std-bold ${headerFontClass}`}>
                {baseProps.twilioStatusModel?.failed ? 'SMS Code Failed to Send…' : 'Enter verification code'}
            </h2>

            <div className="text-color-gray-16 font-19 mb-3">
                {
                    baseProps.twilioStatusModel?.failed
                        ? `We cannot send you a verification code via SMS to ${baseProps.user?.mobile} `
                        : `Please enter the 5 digit verification code sent to ${baseProps.user?.mobile} `
                }
                <a href="#" className="link-primary text-underline" onClick={() => goToStep(UpsellPanelSteps.Step4MobileUpdate)}>
                    Change number
                </a>
            </div>
            <img className="py-32" src={Helpers.getBlobFileUrl("/images/Verification-step-3.webp")} alt="start trial" title="start trial" />
        </div>
    );
};
